"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[75413],{

/***/ 75626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ OrderAction; }
/* harmony export */ });
/* unused harmony export OrderStatus */
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));


/***/ }),

/***/ 91037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ ActionTarget; },
/* harmony export */   "F4": function() { return /* binding */ PlatformOrderTypes; },
/* harmony export */   "IC": function() { return /* binding */ OrderSecuritiesKindType; },
/* harmony export */   "iX": function() { return /* binding */ OrderAction; },
/* harmony export */   "l5": function() { return /* binding */ ForcedSellMapper; },
/* harmony export */   "oU": function() { return /* binding */ OrderSide; },
/* harmony export */   "pD": function() { return /* binding */ OrderForceSellType; },
/* harmony export */   "pY": function() { return /* binding */ SecuritiesKind; },
/* harmony export */   "vT": function() { return /* binding */ iOrderSide; }
/* harmony export */ });
/* unused harmony exports OrderStatus, LeverageType */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var SecuritiesKind;
(function(SecuritiesKind) {
    SecuritiesKind[SecuritiesKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    SecuritiesKind[SecuritiesKind["STOCK"] = 1] = "STOCK";
    SecuritiesKind[SecuritiesKind["BOND"] = 2] = "BOND";
})(SecuritiesKind || (SecuritiesKind = {}));
var OrderSecuritiesKindType;
(function(OrderSecuritiesKindType) {
    OrderSecuritiesKindType["Unspecified"] = "SECURITIES_KIND_UNSPECIFIED";
    OrderSecuritiesKindType["Stock"] = "SECURITIES_KIND_STOCK";
    OrderSecuritiesKindType["Bond"] = "SECURITIES_KIND_BOND";
})(OrderSecuritiesKindType || (OrderSecuritiesKindType = {}));
var PlatformOrderTypes;
(function(PlatformOrderTypes) {
    PlatformOrderTypes["UNSPECIFIED"] = "PLATFORM_ORDER_TYPE_UNSPECIFIED";
    PlatformOrderTypes["LIMIT"] = "PLATFORM_ORDER_TYPE_LIMIT_DAY";
    PlatformOrderTypes["FAK"] = "PLATFORM_ORDER_TYPE_MARKET_FAK";
    PlatformOrderTypes["FAST_ORDER"] = "PLATFORM_ORDER_TYPE_FAST_ORDER";
})(PlatformOrderTypes || (PlatformOrderTypes = {}));
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var iOrderSide;
(function(iOrderSide) {
    iOrderSide[iOrderSide["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    iOrderSide[iOrderSide["BUY"] = 1] = "BUY";
    iOrderSide[iOrderSide["SELL"] = 2] = "SELL";
})(iOrderSide || (iOrderSide = {}));
var OrderSide;
(function(OrderSide) {
    OrderSide["Unspecified"] = "SIDE_UNSPECIFIED";
    OrderSide["Buy"] = "SIDE_BUY";
    OrderSide["Sell"] = "SIDE_SELL";
})(OrderSide || (OrderSide = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));
var OrderForceSellType;
(function(OrderForceSellType) {
    OrderForceSellType["Unspecified"] = "DAY_TRADE_FORCE_SELL_UNSPECIFIED";
    OrderForceSellType["DebtRatio"] = "DAY_TRADE_FORCE_SELL_DEBT_RATIO";
    OrderForceSellType["TimeLimit"] = "DAY_TRADE_FORCE_SELL_TIME_LIMIT";
})(OrderForceSellType || (OrderForceSellType = {}));
var LeverageType;
(function(LeverageType) {
    LeverageType["Unspecified"] = "LEVERAGE_TYPE_TRADING_UNSPECIFIED";
    LeverageType["TradingBalance"] = "LEVERAGE_TYPE_TRADING_BALANCE";
    LeverageType["TradingLimit"] = "LEVERAGE_TYPE_TRADING_LIMIT";
    LeverageType["BasicLimit"] = "LEVERAGE_TYPE_BASIC_LIMIT";
    LeverageType["TempLimit"] = "LEVERAGE_TYPE_TEMP_LIMIT";
    LeverageType["DayTrade"] = "LEVERAGE_TYPE_DAY_TRADE";
})(LeverageType || (LeverageType = {}));
var _obj;
var ForcedSellMapper = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.DebtRatio, "FORCED SELL"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.TimeLimit, "FORCED SELL"), _obj);
var ActionTarget;
(function(ActionTarget) {
    ActionTarget["UNSPECIFIED"] = "ACTION_TARGET_UNSPECIFIED";
    ActionTarget["REGULAR"] = "ACTION_TARGET_REGULAR";
    ActionTarget["DAY_TRADE"] = "ACTION_TARGET_DAY_TRADE";
    ActionTarget["LEGACY_SMARTORDER"] = "ACTION_TARGET_LEGACY_SMARTORDER";
    ActionTarget["TRAILING_STOP"] = "ACTION_TARGET_TRAILING_STOP";
    ActionTarget["STOP_ORDER"] = "ACTION_TARGET_STOP_ORDER";
    ActionTarget["BRACKET_ORDER"] = "ACTION_TARGET_BRACKET_ORDER";
})(ActionTarget || (ActionTarget = {}));


/***/ }),

/***/ 89237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hc": function() { return /* binding */ convertSmartOrderConfigType; },
/* harmony export */   "KH": function() { return /* binding */ convertSecuritiesKind; },
/* harmony export */   "TQ": function() { return /* binding */ lotFormatter; },
/* harmony export */   "a$": function() { return /* binding */ getExercisedData; },
/* harmony export */   "aF": function() { return /* binding */ getHourFromTimestamp; },
/* harmony export */   "gg": function() { return /* binding */ convertTimestampToDate; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "y0": function() { return /* binding */ convertBooleanToNumber; },
/* harmony export */   "zn": function() { return /* binding */ convertForceSellEvent; }
/* harmony export */ });
/* unused harmony exports formatToLocalDate, convertGoogleDateToTimestamp */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78343);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42298);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91037);


var HOUR_OFFSET = -7;
var convertBooleanToNumber = function(bool) {
    return bool ? 1 : 0;
};
var formatToLocalDate = function(date, customFormat) {
    var adjustedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(date, HOUR_OFFSET);
    var formattedHour = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(adjustedDate, customFormat);
    return formattedHour;
};
var convertTimestampToDate = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "yyyy-MM-dd HH:mm:ss");
};
var convertGoogleDateToTimestamp = function(date) {
    if (!date) return "";
    var year = date.year, month = date.month, day = date.day;
    var jsDate = new Date(year, month - 1, day + 1);
    return formatToLocalDate(jsDate, "dd-MM-yyyy");
};
var getHourFromTimestamp = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "HH:mm:ss");
};
var getTime = function(timestamp) {
    if (!timestamp) return "";
    return Number(timestamp.seconds) * 1000;
};
var getExercisedData = function(exercise) {
    if (!exercise) return null;
    var active = exercise.active, type = exercise.type, price = exercise.price, info = exercise.info, date = exercise.date;
    return {
        active: active,
        type: type,
        price: price,
        info: info,
        listing_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.listing),
        expired_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.expired),
        mature_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.mature),
        exercise_start_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.start),
        exercise_end_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.end)
    };
};
var convertForceSellEvent = function(event) {
    switch(event){
        case 1:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.DebtRatio */ .pD.DebtRatio;
        case 2:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.TimeLimit */ .pD.TimeLimit;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.Unspecified */ .pD.Unspecified;
    }
};
var convertSmartOrderConfigType = function(configType) {
    switch(configType){
        case "CONFIG_PRICE_TYPE_ABOVE":
            return "1";
        case "CONFIG_PRICE_TYPE_BELOW":
            return "2";
        default:
            return configType;
    }
};
var convertSecuritiesKind = function(kind) {
    switch(kind){
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.STOCK */ .pY.STOCK:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Stock */ .IC.Stock;
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.BOND */ .pY.BOND:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Bond */ .IC.Bond;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Unspecified */ .IC.Unspecified;
    }
};
var lotFormatter = function(value) {
    return Intl.NumberFormat("en-US").format(value);
};


/***/ }),

/***/ 75413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export convertSideToAction */
/* harmony import */ var utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89237);
/* harmony import */ var global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75626);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91037);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83153);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2078);





var convertSideToAction = function(side) {
    return side === global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_2__/* .OrderSide.Buy */ .oU.Buy ? global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Buy */ .i.Buy : global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Sell */ .i.Sell;
};
var portfolioItem = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, asset = ref.asset, company = ref.company, exercise = ref.exercise, flags = ref.flags, price = ref.price, qty = ref.qty, symbol = ref.symbol, type = ref.type, info = ref.info, bond = ref.bond, can_create_smart_order = ref.can_create_smart_order, is_sharia = ref.is_sharia;
    return {
        allow_order: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(flags === null || flags === void 0 ? void 0 : flags.allow_order),
        amount_invested: asset === null || asset === void 0 ? void 0 : asset.amount_invested,
        available_lot: qty === null || qty === void 0 ? void 0 : qty.available.lot,
        available_share: qty === null || qty === void 0 ? void 0 : qty.available.share,
        balance_lot: qty === null || qty === void 0 ? void 0 : qty.balance.lot,
        balance_share: qty === null || qty === void 0 ? void 0 : qty.balance.share,
        company_name: company === null || company === void 0 ? void 0 : company.name,
        exercise_data: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .getExercisedData */ .a$)(exercise),
        exercise_type: exercise === null || exercise === void 0 ? void 0 : exercise.type,
        have_smartorder: flags === null || flags === void 0 ? void 0 : flags.have_smart_order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_latest: price === null || price === void 0 ? void 0 : price.latest,
        stock_on_hand: qty === null || qty === void 0 ? void 0 : qty.stock_on_hand,
        symbol: symbol,
        total: asset === null || asset === void 0 ? void 0 : asset.amount_invested,
        unrealised_gain: asset === null || asset === void 0 ? void 0 : asset.unrealised.gain,
        unrealised_marketvalue: asset === null || asset === void 0 ? void 0 : asset.unrealised.market_value,
        unrealised_profitloss: asset === null || asset === void 0 ? void 0 : asset.unrealised.profit_loss,
        type: type !== null && type !== void 0 ? type : "",
        info: info !== null && info !== void 0 ? info : [],
        bond: bond !== null && bond !== void 0 ? bond : undefined,
        show_create_smartorder: can_create_smart_order !== null && can_create_smart_order !== void 0 ? can_create_smart_order : false,
        can_buy: flags === null || flags === void 0 ? void 0 : flags.can_buy,
        can_sell: flags === null || flags === void 0 ? void 0 : flags.can_sell,
        is_sharia: is_sharia
    };
};
var portfolioItemFromBonds = function(data) {
    var ref, ref1, ref2, ref3;
    return {
        allow_order: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(true),
        amount_invested: data === null || data === void 0 ? void 0 : data.invested_amount,
        available_lot: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        available_share: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        balance_lot: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        balance_share: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        company_name: data.product.name,
        exercise_data: undefined,
        exercise_type: undefined,
        have_smartorder: false,
        price_average: data === null || data === void 0 ? void 0 : data.price_rate,
        price_average_fee: data === null || data === void 0 ? void 0 : data.price_rate,
        price_latest: undefined,
        stock_on_hand: data === null || data === void 0 ? void 0 : data.invested_amount,
        symbol: data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.identifier,
        total: data === null || data === void 0 ? void 0 : data.total_portfolio,
        unrealised_gain: (data === null || data === void 0 ? void 0 : (ref1 = data.profit_loss) === null || ref1 === void 0 ? void 0 : ref1.percentage) / 100,
        unrealised_marketvalue: data === null || data === void 0 ? void 0 : data.market_value,
        unrealised_profitloss: data === null || data === void 0 ? void 0 : (ref2 = data.profit_loss) === null || ref2 === void 0 ? void 0 : ref2.amount,
        type: constants_trading__WEBPACK_IMPORTED_MODULE_3__/* .STOCK_TYPE.bond */ .L2.bond,
        info: undefined,
        bond: undefined,
        show_create_smartorder: false,
        bond_sell_enabled: parseInt(data === null || data === void 0 ? void 0 : data.units, 10) > 0,
        is_sharia: data === null || data === void 0 ? void 0 : (ref3 = data.product) === null || ref3 === void 0 ? void 0 : ref3.is_sharia,
        can_buy: false,
        can_sell: false
    };
};
var portfolioList = function(portfolio) {
    var ref = portfolio !== null && portfolio !== void 0 ? portfolio : {}, summary = ref.summary, smart_order_info = ref.smart_order_info, stockPortfolios = ref.results, day_trade = ref.day_trade;
    var result = stockPortfolios.map(function(stockPortfolio) {
        return portfolioItem(stockPortfolio);
    });
    return {
        tradingbalance: summary === null || summary === void 0 ? void 0 : summary.trading.balance,
        amount_allocated: summary === null || summary === void 0 ? void 0 : summary.amount.allocated,
        amount_creditlimit: summary === null || summary === void 0 ? void 0 : summary.amount.credit_limit,
        unrealised_profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.unrealised,
        realised_profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.realised,
        show_create_smartorder: smart_order_info === null || smart_order_info === void 0 ? void 0 : smart_order_info.can_create,
        auto_order_info: smart_order_info === null || smart_order_info === void 0 ? void 0 : smart_order_info.info,
        day_trade: day_trade === null || day_trade === void 0 ? void 0 : day_trade.map(function(item) {
            return portfolioItem(item);
        }),
        debt_ratio: summary === null || summary === void 0 ? void 0 : summary.debt.ratio,
        debt_total: summary === null || summary === void 0 ? void 0 : summary.debt.total,
        debt_market_value: summary === null || summary === void 0 ? void 0 : summary.debt.market_value,
        amount_invested: summary === null || summary === void 0 ? void 0 : summary.amount.invested,
        gain: summary === null || summary === void 0 ? void 0 : summary.gain,
        profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.net,
        equity: summary === null || summary === void 0 ? void 0 : summary.equity,
        result: result
    };
};
var orderDetail = function(order) {
    var ref;
    var ref1 = order !== null && order !== void 0 ? order : {}, action = ref1.action, amount = ref1.amount, day_trade = ref1.day_trade, gtc = ref1.gtc, market_order_id = ref1.market_order_id, message = ref1.message, order_id = ref1.order_id, price = ref1.price, qty = ref1.qty, side = ref1.side, securities_kind = ref1.securities_kind, smart_order = ref1.smart_order, status_text = ref1.status_text, symbol = ref1.symbol, time = ref1.time, is_sharia = ref1.is_sharia, platform_order_type = ref1.platform_order_type;
    var isBond = securities_kind === "SECURITIES_KIND_BOND";
    var isFAK = platform_order_type === global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_4__/* .PlatformOrderTypes.FAK */ .F4.FAK;
    var gtc_text = "DAY";
    if (isFAK) gtc_text = "FAK";
    else if (gtc === null || gtc === void 0 ? void 0 : gtc.is_gtc) gtc_text = "GTC";
    var ref2, ref3, ref4, ref5, ref6;
    return {
        action: convertSideToAction(side),
        amend_action: action === null || action === void 0 ? void 0 : action.can_amend,
        amend_target: action === null || action === void 0 ? void 0 : action.amend_target,
        amount: amount === null || amount === void 0 ? void 0 : amount.amount,
        amount_fee: amount === null || amount === void 0 ? void 0 : amount.fee.amount,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_invested_fee: isBond ? undefined : amount === null || amount === void 0 ? void 0 : amount.fee.invested,
        amount_matched: isBond ? amount === null || amount === void 0 ? void 0 : (ref = amount.fee) === null || ref === void 0 ? void 0 : ref.invested : amount === null || amount === void 0 ? void 0 : amount.matched,
        amount_matched_broker_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.broker,
        amount_matched_exchange_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.exchange,
        amount_matched_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.amount,
        amount_matched_total: amount === null || amount === void 0 ? void 0 : amount.matched_total,
        amount_open: amount === null || amount === void 0 ? void 0 : amount.open,
        amount_open_fee: amount === null || amount === void 0 ? void 0 : amount.fee.open,
        cancel_action: action === null || action === void 0 ? void 0 : action.can_cancel,
        cancel_target: action === null || action === void 0 ? void 0 : action.cancel_target,
        config_type: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertSmartOrderConfigType */ .Hc)(smart_order === null || smart_order === void 0 ? void 0 : smart_order.config_type),
        gtc_text: gtc_text,
        gtc: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(gtc === null || gtc === void 0 ? void 0 : gtc.is_gtc),
        label: isFAK ? "MO" : smart_order === null || smart_order === void 0 ? void 0 : smart_order.label,
        market_orderid: market_order_id,
        message: message,
        order_done: isBond ? undefined : qty === null || qty === void 0 ? void 0 : qty.lot_done,
        order_open: qty === null || qty === void 0 ? void 0 : qty.lot_open,
        order_total: isBond ? undefined : qty === null || qty === void 0 ? void 0 : qty.lot_total,
        orderid: order_id,
        price: price === null || price === void 0 ? void 0 : price.order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_average_portfolio: price === null || price === void 0 ? void 0 : price.average.portfolio,
        price_order: price === null || price === void 0 ? void 0 : price.order,
        smart_orderid: (ref2 = smart_order === null || smart_order === void 0 ? void 0 : smart_order.order_id) !== null && ref2 !== void 0 ? ref2 : smart_order === null || smart_order === void 0 ? void 0 : smart_order.id,
        status: status_text,
        symbol: symbol,
        securities_kind: securities_kind,
        time: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .getHourFromTimestamp */ .aF)((ref3 = time === null || time === void 0 ? void 0 : time.open) !== null && ref3 !== void 0 ? ref3 : time === null || time === void 0 ? void 0 : time.opened_at),
        time_match: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertTimestampToDate */ .gg)((ref4 = time === null || time === void 0 ? void 0 : time.match) !== null && ref4 !== void 0 ? ref4 : time === null || time === void 0 ? void 0 : time.matched_at),
        time_open: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertTimestampToDate */ .gg)((ref5 = time === null || time === void 0 ? void 0 : time.open) !== null && ref5 !== void 0 ? ref5 : time === null || time === void 0 ? void 0 : time.opened_at),
        trigger_price: smart_order === null || smart_order === void 0 ? void 0 : smart_order.trigger_price,
        day_trade_is_day_trade: day_trade === null || day_trade === void 0 ? void 0 : day_trade.is_day_trade,
        day_trade_force_sell_event: day_trade === null || day_trade === void 0 ? void 0 : day_trade.force_sell_event,
        day_trade_message: (ref6 = day_trade === null || day_trade === void 0 ? void 0 : day_trade.message) !== null && ref6 !== void 0 ? ref6 : "",
        is_sharia: is_sharia,
        trailing_stop: smart_order === null || smart_order === void 0 ? void 0 : smart_order.trailing_stop,
        platform_order_type: platform_order_type
    };
};
var orderList = function(orders) {
    var mappedData = orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
        return orderDetail(order);
    });
    return mappedData;
};
var formulaData = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, version = ref.version, formula = ref.formula, fee = ref.fee, preview_fee = ref.preview_fee, day_trade = ref.day_trade;
    var dayTradePreviewFee = (day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee) ? day_trade.preview_fee : preview_fee;
    return {
        version: version,
        fee: {
            buy: fee.buy,
            sell: fee.sell
        },
        formula: {
            buy_amount_broker_fee: formula.buy.broker_fee,
            buy_amount_exchange_fee: formula.buy.exchange_fee,
            buy_amount_fee: formula.buy.fee,
            buy_amount_invested: formula.buy.invested,
            buy_amount_invested_fee: formula.buy.invested_fee,
            ca_sell_amount_broker_fee: formula.ca_sell.broker_fee,
            ca_sell_amount_exchange_fee: formula.ca_sell.exchange_fee,
            ca_sell_amount_fee: formula.ca_sell.fee,
            ca_sell_amount_invested: formula.ca_sell.invested,
            ca_sell_amount_invested_fee: formula.ca_sell.invested_fee,
            sell_amount_broker_fee: formula.sell.broker_fee,
            sell_amount_exchange_fee: formula.sell.exchange_fee,
            sell_amount_fee: formula.sell.fee,
            sell_amount_invested: formula.sell.invested,
            sell_amount_invested_fee: formula.sell.invested_fee,
            sell_gain: formula.sell_gain,
            sell_profit_loss: formula.sell_profit_loss,
            amount_invested: formula.amount_invested,
            summary_equity: formula.summary.equity,
            summary_invested: formula.summary.invested,
            summary_net_profit_loss: formula.summary.net_profit_loss.value,
            summary_net_profit_loss_percentage: formula.summary.net_profit_loss.percentage,
            unrealised_gain: formula.unrealized.gain,
            unrealised_market_value: formula.unrealized.market_value,
            unrealised_profit_loss: formula.unrealized.profit_loss,
            day_trade_debt_ratio: formula.day_trade.debt.ratio,
            day_trade_debt_unrealized: formula.day_trade.debt.unrealized,
            day_trade_portion_order_amount: formula.day_trade.portion_order_amount,
            day_trade_investment_day_trade: formula.day_trade.investment.day_trade,
            day_trade_investment_portion_tb: formula.day_trade.investment.portion_tb,
            fee_buy: fee.buy,
            fee_sell: fee.sell,
            fee_buy_day_trade: day_trade.fee.buy,
            fee_sell_day_trade: day_trade.fee.sell
        },
        preview_fee: {
            broker_fee: preview_fee.broker_fee,
            exchange: {
                compositions: preview_fee.exchange.compositions,
                title: preview_fee.exchange.title,
                desc: preview_fee.exchange.desc,
                subtitle: preview_fee.exchange.subtitle,
                exchange_fee_total_buy: preview_fee.exchange.total_buy,
                exchange_fee_total_ca_buy: preview_fee.exchange.total_ca_buy,
                exchange_fee_total_ca_sell: preview_fee.exchange.total_ca_sell,
                exchange_fee_total_sell: preview_fee.exchange.total_sell,
                exchange_fee_total_title: preview_fee.exchange.total_title
            }
        },
        day_trade: {
            fee: {
                buy: day_trade.fee.buy,
                sell: day_trade.fee.sell
            },
            portion_deduct_to_tb: day_trade.portion_deduct_to_tb,
            preview_fee: {
                broker_fee: dayTradePreviewFee.broker_fee,
                exchange: {
                    compositions: dayTradePreviewFee.exchange.compositions,
                    title: dayTradePreviewFee.exchange.title,
                    desc: dayTradePreviewFee.exchange.desc,
                    subtitle: dayTradePreviewFee.exchange.subtitle,
                    exchange_fee_total_buy: dayTradePreviewFee.exchange.total_buy,
                    exchange_fee_total_ca_buy: dayTradePreviewFee.exchange.total_ca_buy,
                    exchange_fee_total_ca_sell: dayTradePreviewFee.exchange.total_ca_sell,
                    exchange_fee_total_sell: dayTradePreviewFee.exchange.total_sell,
                    exchange_fee_total_title: dayTradePreviewFee.exchange.total_title
                }
            }
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    portfolioItem: portfolioItem,
    portfolioList: portfolioList,
    orderDetail: orderDetail,
    orderList: orderList,
    formulaData: formulaData,
    portfolioItemFromBonds: portfolioItemFromBonds
});


/***/ })

}]);